// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7f2a6faf","500":"a8079360"}[chunkId] + ".chunk.js";
};